/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import CreatePatient from './CreatePatient/index'
import GoToPatientProfile from './GoToPatientProfile/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function PatientAction({
  children,
  viewPath = "/DesignSystem/LeadPreview/Content/PatientAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let leadValueData = fromData.useDataFormat({ viewPath,
context: 'lead',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: leadValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CreatePatient'}>
<CreatePatient
  viewPath={`${viewPath}/CreatePatient`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'GoToPatientProfile'}>
<GoToPatientProfile
  viewPath={`${viewPath}/GoToPatientProfile`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}